import clsx from 'clsx';
import React, { CSSProperties } from 'react';

import { SectionsAndTemplates, Template } from '../../templates';
import { TemplateCard } from '../template-card/template-card';
import { TemplateTitle } from '../template-title/template-title';

import styles from './available-templates.scss';

interface AvailableTemplatesProps {
  className?: string;
  data: SectionsAndTemplates[];
  isSheetAccessible?: boolean;
  onOpenTemplate?: (template: Template) => void;
  style?: CSSProperties;
}

export const AvailableTemplates = ({
  className,
  data,
  isSheetAccessible,
  onOpenTemplate,
  style
}: AvailableTemplatesProps) => {
  return (
    <div data-testid="import-available-templates" className={className} style={style}>
      {data.map((section, sectionIndex) => (
        <section
          className={clsx({
            [styles.templateContainer]: true,
            [styles.templateContainerDisabled]: !isSheetAccessible
          })}
          key={`template-section${sectionIndex}`}
        >
          <TemplateTitle icon={section.sectionIcon} title={section.sectionTitle} />

          <div className={styles.templateCards}>
            {section.templates.map((template, templateIndex) => (
              <TemplateCard
                disabled={!isSheetAccessible}
                key={`template-section${sectionIndex}-template${templateIndex}`}
                onOpenTemplate={() => onOpenTemplate?.(template)}
                template={template}
              />
            ))}
          </div>
        </section>
      ))}
    </div>
  );
};
